const CLOSED_STAGE_STATUSES = ["Completed", "Approved", "Not Applicable"];
const ACTIVE_STAGE_STATUSES = ["Ready", "In Progress", "Internal Review", "Submitted", "Awaiting Client", "Awaiting External"];
const BAD_STAGE_STATUSES = ["Blocked", "Correction Required"];

export const isStageClosedStatus = (status) => CLOSED_STAGE_STATUSES.includes(String(status || ""));
// 历史阶段可能已经登记完成时间但状态未同步；显示与后端阶段统计都认这一结论。
export const isStageClosed = (stage) => Boolean(stage && (isStageClosedStatus(stage.status) || stage.actualFinish));

export const stageStatusOfMembers = (members = []) => {
  if (!members.length) return "Not Started";
  if (members.every(isStageClosed)) return "Completed";

  const bad = BAD_STAGE_STATUSES.find((status) => members.some((member) => !isStageClosed(member) && member.status === status));
  if (bad) return bad;

  const inProgress = members.find((member) => !isStageClosed(member) && ACTIVE_STAGE_STATUSES.includes(member.status) && member.status !== "Ready");
  if (inProgress) return inProgress.status;

  // One completed member means the merged unit has started, even if its next
  // member is still Not Started. Not Applicable alone does not count as work.
  if (members.some((member) => ["Completed", "Approved"].includes(member.status) || member.actualFinish)) return "In Progress";

  return members.find((member) => !isStageClosed(member) && ACTIVE_STAGE_STATUSES.includes(member.status))?.status
    || members.find((member) => !isStageClosed(member))?.status
    || "Not Started";
};
